module.exports = __webpack_public_path__ + "img/bank.07a36f81.png";